export default __webpack_public_path__ + "static/media/90_photo.ac6a201f.jpg";